import {HR_ID_COLUMN, NAME_COLUMN} from "../constants";

export const validateHeaders = (dynamicFields, headers) => {
    const errors = {
        missingFields: new Set(),
        unexpectedFields: new Set(),
    };

    const dynamicSet = new Set(dynamicFields);
    const headersSet = new Set(headers);

    dynamicFields.forEach((field) => {
        if (!headersSet.has(field)) {
            errors.missingFields.add(field);
        }
    });

    headers.forEach((field) => {
        if (!dynamicSet.has(field)) {
            errors.unexpectedFields.add(field);
        }
    });

    const missing = Array.from(errors.missingFields);
    const unexpected = Array.from(errors.unexpectedFields);

    if (missing.length > 0 || unexpected.length > 0) {
        const missingMessage = missing.length > 0 ? `missing dynamic fields: ${missing.join(", ")}` : "";
        const unexpectedMessage = unexpected.length > 0 ? `unexpected dynamic fields: ${unexpected.join(", ")}` : "";
        const separator = missing.length > 0 && unexpected.length > 0 ? "; " : "";

        return `Headers mismatch: ${missingMessage}${separator}${unexpectedMessage}`;
    }

    return null;
};

export const validateIds = (selectedIds, excelIds) => {
    const errors = {
        missingFields: new Set(),
        unexpectedFields: new Set(),
    };

    const dynamicSet = new Set(selectedIds);
    const headersSet = new Set(excelIds);

    selectedIds.forEach((field) => {
        if (!headersSet.has(field)) {
            errors.missingFields.add(field);
        }
    });

    excelIds.forEach((field) => {
        if (!dynamicSet.has(field)) {
            errors.unexpectedFields.add(field);
        }
    });

    const missing = Array.from(errors.missingFields);
    const unexpected = Array.from(errors.unexpectedFields);

    if (missing.length > 0 || unexpected.length > 0) {
        const missingMessage = missing.length > 0 ? `missing HRCloud Employee ID's: ${missing.join(", ")}` : "";
        const unexpectedMessage = unexpected.length > 0 ? `unexpected HRCloud Employee ID's: ${unexpected.join(", ")}` : "";
        const separator = missing.length > 0 && unexpected.length > 0 ? "; " : "";

        return `ID's mismatch: ${missingMessage}${separator}${unexpectedMessage}`;
    }

    return null;
};

export const generateMissingFields = (fileData) => {
    const errors = [];

    fileData.forEach((item) => {
        const missingFields = Object.entries(item)
            .filter(([_, value]) => value === "")
            .map(([key]) => key);

        if (missingFields.length > 0) {
            const employeeName = item[NAME_COLUMN] || 'Unknown Name';
            const employeeId = item[HR_ID_COLUMN] || "Unknown ID";
            const count = missingFields.length;
            const valueText = count === 1 ? 'value is' : 'values are';
            const errorMessage = `${employeeName}(${employeeId}) - ${count} ${valueText} missing: ${missingFields.join(", ")}`;
            errors.push(errorMessage);
        }
    });

    return errors;
}
